var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Customer Update"}},[_c('vs-button',{staticClass:"mt-2",attrs:{"color":"success","type":"border","icon-pack":"feather","icon":"icon-plus"},on:{"click":function($event){return _vm.handleCreate()}}},[_vm._v("Create")]),_c('br'),_c('div',{attrs:{"clss":"vx-row"}},[_c('data-table',{attrs:{"baseUrl":this.baseUrl}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }